export const INSERT_RELATIVE_REQUESTING = "INSERT_RELATIVE_REQUESTING"
export const INSERT_RELATIVE_SUCCESS = "INSERT_RELATIVE_SUCCESS"
export const INSERT_RELATIVE_ERROR = "INSERT_RELATIVE_ERROR"

export const GET_RELATIVES_REQUESTING = "GET_RELATIVES_REQUESTING"
export const GET_RELATIVES_SUCCESS = "GET_RELATIVES_SUCCESS"
export const GET_RELATIVES_ERROR = "GET_RELATIVES_ERROR"
export const RESET_RELATIVE_STORE = "RESET_RELATIVE_STORE"
export const UPDATE_RELATIVE = "UPDATE_RELATIVE"